import * as React from 'react';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  content?: React.ReactNode;
  onClose: () => void;
  title: React.ReactNode;
  open: boolean;
  size?: any;
  footer?: React.ReactNode;
}

export default function CustomizedDialog(props: DialogTitleProps) {
  const { onClose, open, title, content, footer, size } = props;

  return (
    <>
      <BootstrapDialog
        sx={{ borderRadius: 10 }}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth
        maxWidth={size}
        onClose={onClose}
      >
        <DialogTitle sx={{ m: 0, p: 2 }}>
          {title}
          {onClose ? (
            <IconButton
              aria-label="close"
              onClick={onClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>
        <DialogContent sx={{ padding: '2rem' }} dividers>
          <div>{content}</div>
        </DialogContent>
        {footer && <DialogActions>{footer}</DialogActions>}
      </BootstrapDialog>
    </>
  );
}
